import { Typo } from "../../typography";
import styled from "styled-components";
export const CopyrightWrap = styled(Typo) `
  display: flex;
  height: 1.25rem;
  align-items: center;
  color: ${({ theme }) => theme.colors.grey14};
  &&& {
    font-size: ${({ theme }) => theme.fontTokens.font12[0]};
    font-weight: ${({ theme }) => theme.fontWeights.regular};
  }
  margin-top: 0.5rem;
  @media ${({ theme }) => theme.device.medium} {
    height: auto;
    margin-right: ${({ $withMarginRight }) => $withMarginRight ? "1rem" : "0"};
    margin-top: 0;
  }
`;
